export class AppMediaSettings {

    static getVolume() {
        var volume = localStorage.getItem("MediaVolume") ?? ".5";
        return parseFloat(volume);
    }

    static setVolume(volume: number) {
        localStorage.setItem("MediaVolume", volume.toString());
    }

    static getCloseCaptionsLang() {
        return localStorage.getItem("MediaCCLang");
    }

    static setCloseCaptionsLang(ccLang?: string) {
        if (ccLang == null) localStorage.removeItem("MediaCCLang");
        else localStorage.setItem("MediaCCLang", ccLang);
    }
}